<template>
    <div class="content">
        <div class="content-box">

            <div style="width: 700px;" class="content-item">
                <div class="flex-center item-head">
                    <div class="block-title">品牌店金价<span class="block-en-title">Gold price of brand store</span></div>
                    <div class="date font-medium">报价时间：{{ goldPriceUpdateDate }}</div>
                </div>
                <div class="price-list">
                    <div class="price-title flex-center">
                        <div class="item price-type first">品牌</div>
                        <div class="item">
                            <div class="price-type">黄金(￥/g)</div>
                        </div>
                        <div class="item">
                            <div class="price-type">铂金(￥/g)</div>
                        </div>
                        <div class="item">
                            <div class="price-type">金条(￥/g)</div>
                        </div>
                    </div>
                    <div v-for="(price, priceKey) in goldPriceList"
                         class="list flex-center">
                        <div class="flex-center logo">
                            <img class="img" :src="price.logo" alt=""/>
                            <div class="name item">{{ price.name }}</div>
                        </div>
                        <div class="flex-center price">
                            <div class="item">{{ price.price_gold }}</div>
                            <div class="item">{{ price.price_pt }}</div>
                            <div class="item">{{ price.price_gold_bar }}</div>
                        </div>
                    </div>
                </div>
                <div class="declare"><span style="margin-right: 50px">数据来源：金价查询网</span>仅供参考，以门店为准</div>
            </div>


            <div style="width: 500px;" class="content-item">
                <div v-if="bannerList.length" class="banner-area">
                    <el-carousel arrow="never">
                        <el-carousel-item v-for="(item,bannerKey) in bannerList" :key="bannerKey">
                            <img :src="item.img_url" style="object-fit: cover;width:100%;">
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="flex-center">
                    <div class="block-title item-head">黄金回收价<span class="block-en-title">Recovered gold price</span></div>
                    <div class="date font-medium">报价时间：{{ goldRecycleUpdateDate }}</div>
                </div>
                <div class="refund-list">
                    <div v-for="(refund, refundKey) in goldRecycleList"
                         class="list flex-center font-bold">
                        <div class="item">{{ refund.name }}</div>
                        <div class="item">{{ refund.price }} {{ refund.unit }}
                        </div>
                    </div>
                </div>
                <div v-if="false" class="ask" @click="gotoWechat()">回收黄金咨询</div>
            </div>
        </div>
    </div>
</template>

<script>

import {bannerList, goldPrice} from '@/api/api';


export default {
    name: 'GoldPrice',
    props: {},
    data() {
        return {
            goldPriceList: [],
            goldPriceUpdateDate: '',
            goldRecycleList: [],
            goldRecycleUpdateDate: '',
            bannerList: [],
        }
    },
    created() {
        goldPrice({type_id: 3}).then(res => {
            this.goldPriceList = res.data.data.list
            this.goldPriceUpdateDate = res.data.data.update_date
        })
        goldPrice({type_id: 4}).then(res => {
            this.goldRecycleList = res.data.data.list
            this.goldRecycleUpdateDate = res.data.data.update_date
        })
        bannerList({type_id: 4}).then(res => {
            if (res.data.data && res.data.data.length) {
                this.bannerList = res.data.data
            }
        })
    },
    methods: {
        gotoWechat () {
            window.open('https://work.weixin.qq.com/kfid/kfc875a6ce213fef2dc', '_blank')
        }
    }
}
</script>

<style lang="scss">
.content {
    min-height: 100vh;
    display: flex;

    .content-box {
        display: flex;
        margin: 0 auto;
        justify-content: center;
        .content-item{
            margin: 0 20px;
            .item-head{
                margin: 15px 0;
                height: 30px;
            }
            .block-title{
                font-size: 26px;
                font-weight: 500;
                margin-right: 20px;
                color: rgba(41, 43, 44, 1);
            }
            .block-en-title{
                font-size: 14px;
                font-weight: 400;
                color: rgba(166, 166, 166, 1);
            }
        }
    }

    .date{
        margin-left: auto;
        font-size: 16px;
        font-weight: 400;
        color: rgba(114, 113, 113, 1);
        display: flex;
        align-items: flex-end;
        height: 100%;
    }
    .item{
        flex: 1;
        text-align: center;
    }
    .price-list{
        box-shadow: 8px 10px 0 0 rgba(223, 227, 230, 1);
        border: 2px solid rgba(94, 101, 117, 1);
        .price-title{
            padding: 16px 0;
            background: rgba(229, 229, 229, 1);
            .first{
                margin: 0 20px;
                text-align: center;
            }
            .price-type{
                font-size: 20px;
                font-weight: 500;
                color: rgba(26, 26, 26, 1);
            }
        }
        .list{
            padding: 15px 0;
            width: 100%;
            border: none;
            .img{
                width: 50px;
                position: relative;
                left: 20px;
            }
            .name{
                font-size: 18px;
                font-weight: 400;
                color: rgba(26, 26, 26, 1);
            }
            .logo{
                width: 220px;
                margin-left: 30px;
                text-align: center;
            }
            .price{
                width: 100%;
            }
        }
        .list:nth-child(odd) {
            background: rgba(237, 243, 255, 1);
            border-top: 2px solid rgba(221, 227, 235, 1);
            border-bottom: 2px solid rgba(221, 227, 235, 1);
        }
    }

    .refund-list{
        .list{
            width: 100%;
            height: 60px;
            background: rgba(255, 243, 237, 1);
            border: 2px solid rgba(0, 0, 0, 1);
            margin-bottom: 20px;
            box-shadow: 8px 10px 0 0 rgba(240, 240, 240, 1);
            font-size: 18px;
            font-weight: 500;
            color: rgba(41, 43, 44, 1);
            .unit{
                font-size: 20px;
                color: rgba(41, 43, 44, 1);
                position: relative;
                top: -4px;
            }
        }
    }

    .declare{
        margin: 20px 0;
        font-size: 14px;
        font-weight: 400;
        color: rgba(114, 113, 113, 1);
    }
}

.banner-area{
    background: url("https://zbtesting-uploads.oss-cn-shenzhen.aliyuncs.com/zbtesting_v5/m/img/text-gold-short.png");
    background-size: 100%;
    display: flex;
    align-items: center;
    height: 276px;
    margin-bottom: 5px;
    .el-carousel__container{
        height: 135px;
    }
    .el-carousel{
        margin-top: 40px;
        width: 100% ;
    }
}

.ask{
    width: 220px;
    height: 45px;
    border-radius: 23px;
    background: rgba(32, 147, 202, 1);
    margin: auto;

    line-height: 45px;
    font-size: 18px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    vertical-align: top;
}
</style>